import BaseList from 'records/BaseList';
import { SearchFilters } from 'records/SearchFilter'

import {
  SEARCH_BACKGROUND_FILTER_MAINTAIN,
  SEARCH_BACKGROUND_FILTER_RESET_STATE,
  SEARCH_BACKGROUND_FILTER_PAGE_SIZE,
} from 'actions/searchBackgroundFilter';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new SearchFilters(),
  sortKey: null,
});

const actionsMap = {
  [SEARCH_BACKGROUND_FILTER_MAINTAIN]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },

  [SEARCH_BACKGROUND_FILTER_RESET_STATE]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new SearchFilters(),
    });
  },

  [SEARCH_BACKGROUND_FILTER_PAGE_SIZE]: (state, action) => {
    return state.merge({
      sortKey: action.data,
    })
  }

};

export default function searchBackgroundFilter(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
